import { Grid } from "@mui/material";
import React from "react";
import { Dropdown } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { CompanyItem } from "../Company/CompanyItem";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { Translations } from "ui/Scripts/source/models/translations";

interface ICompanyDropdownProps {
    company: ICompanyMenuItem
    companies: ICompanyMenuItem[];
    onSetCompany: (company: ICompanyMenuItem) => void;
}

export const CompanyDropdown = (props: ICompanyDropdownProps) => {
    const handleCompanyChange = (companyId: string) => {
        const company = props.companies.find(i => i.id === companyId);
        if (!company) return;
        props.onSetCompany(company);
    };

    return (
        <Dropdown
            selectedTitle={<Grid sx={{ display: "flex", alignItems: "center" }} ><CompanyItem company={props.company} /></Grid>}
            selectMode={true}
            tooltip={Translations.SelectCompany}
            actions={props.companies.map((company) => {
                return {
                    title: <CompanyItem company={company} />,
                    textTitle: company.name,
                    selected: company.id === props.company?.id,
                    onClick: () => handleCompanyChange(company.id)
                };
            })}
        />
    );
};